import React, { Component } from 'react';
import axios from 'axios';
import { connect } from "react-redux";
import { addLogin } from "../actions/loggedin_action";
import { addProfile } from "../actions/profile_action";
import { setErrorFields, validateField } from "../helpers/validationHelpers";
import LoadingButton from './fields/LoadingButton';
import Notification from './layout/Notification';
import Helping from '../helpers/Helping';

class Login extends Component {
    constructor(props) {
        super(props);

        this.state = {
            url: URL + "admin/login",
            username: "",
            password: "",
            btnIsDisable: false,
            error_message: "",
            error_type: ""
        };

        this.onLogin = this.onLogin.bind(this);
    }

    componentDidMount() {
        let $this = this;

        if (localStorage.token) {
            $this.props.history.push("/dashboard");
        }

        if (localStorage.error_message && !localStorage.error_message.includes("incoming token")) {
            // this.setState({
            //     error_message: localStorage.error_message,
            //     error_type: 'danger'
            // });
            Helping.showNotification('error', localStorage.error_message);
        }
        delete localStorage.error_message;
    }


    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    }

    handleValueChange = async (e) => {
        const { name, value } = e.target;

        if (name === 'username')
            this.setState({ ...(await validateField('string', name, value, '', 1)) });
        if (name === 'password')
            this.setState({ ...(await validateField('string', name, value, '', 1)) });

        this.setState({ [name]: value });
    }

    checkEmptyInputFields = () => {
        let { state } = this,
            formHasError = false;

        if (state.username === "") {
            let errorObject = setErrorFields("username", "Username is required.");
            this.setState(errorObject);
            formHasError = true;
        }

        if (state.password === "") {
            let errorObject = setErrorFields("password", "Password is required");
            this.setState(errorObject);
            formHasError = true;
        }
        return formHasError;
    }

    onLogin(e) {
        e.preventDefault();

        const formHasError = this.checkEmptyInputFields();
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        this.setState({
            btnIsDisable: true
        })

        let $this = this;
        let config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        let data = {
            username: this.state.username,
            password: this.state.password
        };

        axios.post($this.state.url, data, config).then(response => {
            this.setState({ btnIsDisable: false });
            localStorage.token = response.data.payload.accessToken;
            $this.props.addLogin(true);
            window.location.href = "/dashboard";
        })
            .catch(error => {
                if (error.response) {
                    return this.setState({
                        btnIsDisable: false,
                        error_message: error.response.data.message,
                        error_type: 'danger'
                    });
                }
            });
    }

    handleSubmit = (e) => {
        if (e.keyCode === 13) {
            this.onLogin();
        }
    }

    render() {
        return (
            <div class="full-page-container">
                <div class="login-content">
                    <a href="#" class="logo d-block">
                        <img src="./img/TV_Logo.svg" alt="" class="img-fluid" />
                    </a>
                    <form action="" class="login-form">
                        <div class="form-caption">
                            <h3 class="form-title">Sign In</h3>
                            <p>Access the Dashboard panel using your username and password</p>
                        </div>

                        {this.state.error_message &&
                            <Notification
                                type={this.state.error_type}
                                message={this.state.error_message}
                                callback={this.removeNetworkError}
                            />
                        }

                        <div class="form-group">
                            <div class="input-label">
                                <label for="username">Email or Username</label>
                            </div>
                            <input type="text" name="username"
                                class={`form-control ${this.state.error_username_message ? 'error-input' : ''}`} id="username"
                                value={this.state.username}
                                placeholder="Enter your email or username"
                                onKeyDown={(e) => this.handleSubmit(e)}
                                onChange={(e) => this.handleValueChange(e)}
                            />
                            <span className="error-msg">{this.state.error_username_message}</span>
                        </div>
                        <div class="form-group">
                            <div class="input-label">
                                <label for="password">Password</label>
                            </div>
                            <input id="password-field" name="password"
                                type="password" class={`form-control ${this.state.error_password_message ? 'error-input' : ''}`}
                                value={this.state.password}
                                placeholder="Enter your password"
                                onKeyDown={(e) => this.handleSubmit(e)}
                                onChange={(e) => this.handleValueChange(e)}
                            />
                            <span toggle="#password-field" class="fa fa-eye-slash togglePassword"></span>
                            <span className="error-msg">{this.state.error_password_message}</span>
                        </div>

                        {/* <div class="form-group">
                            <label class="form-check">
                                <span class="checkLabel">Remember me</span>
                                <input type="checkbox" class="check-form-input" id="checkbox" />
                                <span class="checkmark"></span>
                            </label>
                        </div> */}

                        {this.state.btnIsDisable ?
                            <LoadingButton classes={"btn login-btn gradiant-btn"} />
                            :
                            <button class="btn login-btn gradiant-btn" onClick={(e) => this.onLogin(e)}>{this.state.btnIsDisable ? "Loading..." : "Login"}</button>
                        }
                    </form>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        isLogin: state.isLogin
    }
}

const mapDispatchToProps = {
    addLogin,
    addProfile
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)
